export default {
  data () {
    return {

    }
  },
  methods: {
    $init_print () {
      let printI = document.createElement('iframe')
      printI.id = 'easyPrintIframe'
      printI.style.position = 'fixed'
      printI.style.width = '0'
      printI.style.height = '0'
      printI.style.top = '-100px'
      // 兼容ie
      if (
        window.location.hostname !== document.domain && navigator.userAgent.match(/msie/i)
      ) {
        printI.src =
                    'javascript:document.write("<head><script>document.domain=\\"' +
                    document.domain +
                    '\\";</s' +
                    'cript></head><body></body>")'
      }
      printI.onload = () => {
        this.$print_getStyle()
      }

      document.body.appendChild(printI)
    },
    browser_print (printRef) {
      this.$init_print()
      if (typeof this.beforeCopy === 'function') {
        // 检测到有复制前需要执行的功能
        this.beforeCopy()
      }
      let $iframe = document.getElementById('easyPrintIframe')
      // 复制body，打印内容
      $iframe.contentDocument.body.innerHTML = this.$refs[printRef].innerHTML
      if (typeof this.beforePrint === 'function') {
        // 检测到有打印前需要执行的功能
        // 比如有些二维码组件无法直接复制dom完成。
        this.beforePrint()
      }
      setTimeout(() => {
        $iframe.contentWindow.print()
      }, 300)
    },
    $print_getStyle () {
      let printI = document.getElementById('easyPrintIframe')
      var str = ''
      var styles1 = document.querySelectorAll('style')
      for (var i = 0; i < styles1.length; i++) {
        str += styles1[i].outerHTML
      }
      printI.contentDocument.head.innerHTML = str
      // 添加link引入
      let styles = document.querySelectorAll('link')
      for (let i = 0; i < styles.length; i++) {
        // chrome 正常，firefox不正常，能执行到，但是添加没结果
        let link = document.createElement('link')
        link.setAttribute('rel', 'stylesheet')
        if (styles[i].type) link.setAttribute('type', styles[i].type)
        else link.setAttribute('type', 'text/css')
        link.setAttribute('href', styles[i].href)
        link.setAttribute('media', 'all')
        printI.contentDocument.head.appendChild(link)
      }
    }
  },
  beforeDestroy () {
    var frame = document.getElementById('easyPrintIframe')
    if (frame) {
      frame.parentNode.removeChild(frame)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/print.js